export default "__VITE_ASSET__D1jCyKr6__"